import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Our named type sizes (index.css @theme --text-*). Without this, tailwind-merge
// reads "text-title" as a text colour and drops real colours like "text-white".
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["meta", "title", "price", "page"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
